import React from 'react'
import DonutChart from './donutData'

const Graficas = () => {

  // const donutData = {
  //   labels: ['Red', 'Blue', 'Yellow'],
  //   datasets: [
  //     {
  //       label: '# of Votes',
  //       data: [12, 19, 3, ],
  //       backgroundColor: [
  //         'rgba(255, 99, 132, 0.6)',
  //         'rgba(54, 162, 235, 0.6)',
  //         'rgba(255, 206, 86, 0.6)'
  //       ],
  //       borderColor: [
  //         'rgba(255, 99, 132, 1)',
  //         'rgba(54, 162, 235, 1)',
  //         'rgba(255, 206, 86, 1)'
  //       ],
  //       borderWidth: 1,
  //     },
  //   ],
  // };

  // const lineData = {
  //   // datos
  //   labels: ['Enero', 'Febrero', 'Marzo', 'Abril'],
  //   datasets: [
  //     {
  //       label: 'Pedidos entregados en el mes anterior',
  //       data: [0, 14, 22, 25, 12], // 0 para el mes actual ya que no lo tienes definido aún
  //       fill: false,
  //       borderColor: 'rgb(255, 99, 132)',
  //       tension: 0.1,
  //     },
  //     {
  //       label: 'Pedidos entregados en el mes actual',
  //       data: [0, 12, 13, 16,22], // 0 para el mes anterior ya que no lo tienes definido
  //       fill: false,
  //       borderColor: 'rgb(75, 192, 192)',
  //       tension: 0.1,
  //     },
  //   ],
  // };

  // const barData = {
  //   labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
  //   datasets: [
  //     {
  //       label: '# of Votes',
  //       data: [12, 19, 3, 5, 2, 3],
  //       backgroundColor: [
  //         'rgba(255, 99, 132, 0.6)',
  //         'rgba(54, 162, 235, 0.6)',
  //         'rgba(255, 206, 86, 0.6)',
  //         'rgba(75, 192, 192, 0.6)',
  //         'rgba(153, 102, 255, 0.6)',
  //         'rgba(255, 159, 64, 0.6)',
  //       ],
  //       borderColor: [
  //         'rgba(255, 99, 132, 1)',
  //         'rgba(54, 162, 235, 1)',
  //         'rgba(255, 206, 86, 1)',
  //         'rgba(75, 192, 192, 1)',
  //         'rgba(153, 102, 255, 1)',
  //         'rgba(255, 159, 64, 1)',
  //       ],
  //       borderWidth: 1,
  //     },
  //   ],
  // };

  // const scatterData = {
  //   datasets: [
  //     {
  //       label: 'A simple Scatter plot',
  //       data: [
  //         { x: 65, y: 75 },
  //         { x: 59, y: 49 },
  //         { x: 80, y: 90 },
  //         { x: 81, y: 29 },
  //         { x: 56, y: 36 },
  //         { x: 55, y: 25 },
  //         { x: 40, y: 18 },
  //       ],
  //       backgroundColor: 'rgba(255, 99, 132, 0.6)',
  //       borderColor: 'rgba(255, 99, 132, 1)',
  //     },
  //   ],
  // };

  return (
    <div className='container-fluid d-flex justify-content-center pb-5 border-bottom border-3'>
      <div className='container p-0 mt-3'>
        <div className='container-lg p-0'>
          <div className='py-3'>
            <p className='short-title font-semibold text-premium-blue mt-4'>Gráficas</p>
          </div>
          <div className='row mt-3 row-gap-3 text-premium-blue'>
            <div className='col-12 col-md-6 d-flex justify-content-center p-5'>

            </div>
            <div className='col-12 col-md-6 d-flex justify-content-center p-5'>
              
            </div>
          </div>
          <div className='row mt-3 row-gap-3 text-premium-blue'>
            <div className='col-12 col-md-6 d-flex justify-content-center p-5'>
              
            </div>
            <div className='col-12 col-md-6 d-flex justify-content-center p-5'>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Graficas